export const onlySpaces = (str) => {
  return str.trim().length === 0;
};
